import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './CommentActions.module.css';

const CommentActions = (props) => {
  let authorActions = null;
  if (props.isAuthor === true || props.isPostAuthor) {
    authorActions = (
      <div>
        {props.enableEdit === true && props.isAuthor === true ? (
          <FontAwesomeIcon icon="pencil-alt" className={classes.Icon} onClick={props.editComment} />
        ) : null}
        <FontAwesomeIcon icon="trash" className={classes.Icon} onClick={props.toggleDeleteCommentDialogue} />
      </div>
    );
  }
  const commentActionsClasses = [classes.CommentActionsContainer];
  if (props.show === true) {
    commentActionsClasses.push(classes.Shown);
  }
  if (props.isPostDetails === true) commentActionsClasses.push(classes.PostDetails);
  commentActionsClasses.push(classes[props.commentType]);
  return (
    <div className={commentActionsClasses.join(' ')}>
      {props.enableReply === true ? (
        <div onClick={props.replyToComment} className={classes.Reply}>
          <span>Reply</span>
        </div>
      ) : null}
      {authorActions}
    </div>
  );
};

export default CommentActions;
